import React from "react";
import {
    ComposableMap,
    Geographies,
    Geography,
    Marker,
    ZoomableGroup
} from "react-simple-maps";

const geoUrl = "https://unpkg.com/world-atlas@2.0.2/countries-110m.json";

const markers = [
    { markerOffset: -15, name: "South Africa", coordinates: [24.9916, -28.4793] },
    { markerOffset: -15, name: "Nigeria", coordinates: [8.6753, 9.0820] },
    { markerOffset: -15, name: "Kenya", coordinates: [37.9062, -0.0236] },
    { markerOffset: -15, name: "Egypt", coordinates: [30.8025, 26.8206] },
    { markerOffset: -15, name: "Ethiopia", coordinates: [40.4897, 9.145] },
    { markerOffset: -15, name: "Ghana", coordinates: [-1.0232, 7.9465] },
    { markerOffset: -15, name: "Morocco", coordinates: [-7.0926, 31.7917] }
];

const WorldMap = ({ markers = [] }) => {
    return (
        <div style={{ width: "100%", height: "300px", backgroundColor: "#f8f9fe", borderRadius: "20px", overflow: "hidden" }}>
            <ComposableMap
                projectionConfig={{
                    scale: 140,
                    center: [20, 0] // Center more on Africa/Europe
                }}
                width={800}
                height={400}
                style={{ width: "100%", height: "100%" }}
            >
                <ZoomableGroup zoom={1}>
                    <Geographies geography={geoUrl}>
                        {({ geographies }) =>
                            geographies.map((geo) => (
                                <Geography
                                    key={geo.rsmKey}
                                    geography={geo}
                                    fill="#EAEAEC"
                                    stroke="#D6D6DA"
                                    strokeWidth={0.5}
                                    style={{
                                        default: { outline: "none" },
                                        hover: { fill: "#1171ef", outline: "none" },
                                        pressed: { outline: "none" }
                                    }}
                                />
                            ))
                        }
                    </Geographies>
                    {markers.map(({ name, coordinates, markerOffset }) => (
                        <Marker key={name} coordinates={coordinates}>
                            <circle r={5} fill="#1171ef" stroke="#fff" strokeWidth={2} />
                            <text
                                textAnchor="middle"
                                y={markerOffset || -15}
                                style={{ fontFamily: "Open Sans, sans-serif", fill: "#525f7f", fontSize: "10px", fontWeight: "bold" }}
                            >
                                {name}
                            </text>
                        </Marker>
                    ))}
                </ZoomableGroup>
            </ComposableMap>
        </div>
    );
};

export default WorldMap;
